import { Link } from "react-router-dom";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="what-app min-h-screen grid place-items-center px-6 py-16">
    <div className="w-full max-w-sm what-rise">
      <Link to="/login" className="flex items-baseline gap-2 mb-10" data-testid="auth-shell-home">
        <span className="font-display text-3xl font-extrabold tracking-tight text-white">WHAT?</span>
        <span className="what-dot" />
      </Link>
      <h1 data-testid="auth-shell-title" className="font-display text-3xl font-bold text-white tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-slate-400 mt-2">{subtitle}</p>}
      <div className="mt-8">{children}</div>
      <Link to="/login" data-testid="back-to-login-link" className="block text-sm text-[#D4FF3A] hover:underline mt-6">Back to log in</Link>
    </div>
  </div>
);
